export const ordersMenu = {
    name: 'Orders',
    paths: [
        {
            label: 'Orders',
            path: '/orders'
        },
    ]
};
